import React from "react";
import { Trash2 } from "lucide-react";

interface TeacherItemProps {
  teacher: {
    id: string;
    fullname: string;
    email: string;
    created_at: string;
    school?: string;
  };
  schoolName: string;
  onDelete: (teacher: {
    id: string;
    fullname: string;
    email: string;
    created_at: string;
    school?: string;
  }) => void;
}

export function TeacherItem({
  teacher,
  schoolName,
  onDelete,
}: TeacherItemProps) {
  return (
    <tr key={teacher.id}>
      <td className="px-6 py-4">
        <div className="text-sm font-medium text-gray-900">
          {teacher.fullname}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">{teacher.email}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {schoolName || "Not assigned"}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {new Date(teacher.created_at).toLocaleDateString()}
        </div>
      </td>
      <td className="px-6 py-4">
        <button
          onClick={() => onDelete(teacher)}
          className="text-red-400 hover:text-red-600 transition-colors"
          title="Delete Teacher"
        >
          <Trash2 className="h-5 w-5" />
        </button>
      </td>
    </tr>
  );
}
